/**
 * MitEvida API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { InvoicesResponse } from '../model/models';
import { ValidationErrorResponse } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param invoicesToFetch Number of invoices to retrieve. Should be less than 100.
     * @param customerNumber 
     * @param installationNumber 
     * @param continuationToken The token previously received in a MitEvida.BFF.REST.Features.Invoice.API.Models.InvoicesResponse. Will allow the API to continue to fetch the next element. Should be null if you wish to receive the first items.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiInvoiceCustomerCustomerNumberInstallationInstallationNumberInvoicesGet(invoicesToFetch: number, customerNumber: string, installationNumber: string, continuationToken?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<InvoicesResponse>;
    public apiInvoiceCustomerCustomerNumberInstallationInstallationNumberInvoicesGet(invoicesToFetch: number, customerNumber: string, installationNumber: string, continuationToken?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<InvoicesResponse>>;
    public apiInvoiceCustomerCustomerNumberInstallationInstallationNumberInvoicesGet(invoicesToFetch: number, customerNumber: string, installationNumber: string, continuationToken?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<InvoicesResponse>>;
    public apiInvoiceCustomerCustomerNumberInstallationInstallationNumberInvoicesGet(invoicesToFetch: number, customerNumber: string, installationNumber: string, continuationToken?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (invoicesToFetch === null || invoicesToFetch === undefined) {
            throw new Error('Required parameter invoicesToFetch was null or undefined when calling apiInvoiceCustomerCustomerNumberInstallationInstallationNumberInvoicesGet.');
        }
        if (customerNumber === null || customerNumber === undefined) {
            throw new Error('Required parameter customerNumber was null or undefined when calling apiInvoiceCustomerCustomerNumberInstallationInstallationNumberInvoicesGet.');
        }
        if (installationNumber === null || installationNumber === undefined) {
            throw new Error('Required parameter installationNumber was null or undefined when calling apiInvoiceCustomerCustomerNumberInstallationInstallationNumberInvoicesGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (invoicesToFetch !== undefined && invoicesToFetch !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>invoicesToFetch, 'InvoicesToFetch');
        }
        if (continuationToken !== undefined && continuationToken !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>continuationToken, 'ContinuationToken');
        }

        let headers = this.defaultHeaders;

        // authentication (idm) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<InvoicesResponse>(`${this.configuration.basePath}/api/Invoice/customer/${encodeURIComponent(String(customerNumber))}/installation/${encodeURIComponent(String(installationNumber))}/invoices`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Downloads the PDF of a specific invoice for a customer.
     * Authorization: the caller must be authenticated and authorized for the given customerNumber.  The invoice is fetched directly from Xellent using the pre-generated PDF; no session state is persisted.  Replaces the legacy 3-step flow (&#x60;download-id&#x60;, &#x60;status&#x60;, &#x60;download&#x60;) that suffered from  broken access control and Guid-encoding collisions — see AB#27973.
     * @param customerNumber The Xellent customer number the invoice belongs to.
     * @param invoiceId The Xellent invoice identifier.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiInvoiceCustomerCustomerNumberInvoiceInvoiceIdPdfGet(customerNumber: string, invoiceId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Blob>;
    public apiInvoiceCustomerCustomerNumberInvoiceInvoiceIdPdfGet(customerNumber: string, invoiceId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Blob>>;
    public apiInvoiceCustomerCustomerNumberInvoiceInvoiceIdPdfGet(customerNumber: string, invoiceId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Blob>>;
    public apiInvoiceCustomerCustomerNumberInvoiceInvoiceIdPdfGet(customerNumber: string, invoiceId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (customerNumber === null || customerNumber === undefined) {
            throw new Error('Required parameter customerNumber was null or undefined when calling apiInvoiceCustomerCustomerNumberInvoiceInvoiceIdPdfGet.');
        }
        if (invoiceId === null || invoiceId === undefined) {
            throw new Error('Required parameter invoiceId was null or undefined when calling apiInvoiceCustomerCustomerNumberInvoiceInvoiceIdPdfGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (idm) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/api/Invoice/customer/${encodeURIComponent(String(customerNumber))}/invoice/${encodeURIComponent(String(invoiceId))}/pdf`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param customerNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiInvoiceInvoiceArchivePost(customerNumber?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<any>;
    public apiInvoiceInvoiceArchivePost(customerNumber?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<any>>;
    public apiInvoiceInvoiceArchivePost(customerNumber?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<any>>;
    public apiInvoiceInvoiceArchivePost(customerNumber?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (customerNumber !== undefined && customerNumber !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>customerNumber, 'customerNumber');
        }

        let headers = this.defaultHeaders;

        // authentication (idm) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/api/Invoice/invoiceArchive`,
            null,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
